{
  "version": 1,
  "asset_id": "913db105-c411-4a1a-ad74-b478ff4a0dc2",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/913db105-c411-4a1a-ad74-b478ff4a0dc2/interior-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/913db105-c411-4a1a-ad74-b478ff4a0dc2/interior-card.webp",
  "original_filename": "interior-card.webp",
  "size": 38408,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:46Z"
}
